import React, {Component} from 'react';
import ReactNotify from 'react-notify';
import $ from "jquery";
import DateAndTimeFormat from "../../../../../utilities/DateAndTimeFormat";
import TopIf from "../../../../../componentsTopsa/if/TopIf";
import {TopButtonAction} from "../../../../../componentsTopsa/buttons/TopButtons";
import KonfiguracjaService from "../../../../administracja/konfiguracja/KonfiguracjaService";
import KalendarzEventMenu from "./components/KalendarzEventMenu";
import KalendarzModalZmienStatus from "./components/modalComponents/KalendarzModalZmienStatus";
import KalendarzModalEdytujZasoby from "./components/modalComponents/KalendarzModalEdytujZasoby";
import LSService from "../../../../../utilities/localStorageService/LSService";
import KalendarzModalDuplikujKurs from "./components/modalComponents/KalendarzModalDuplikujKurs";


export default class ObsadaKalendarzContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            events: [],
            event: null,
            pokazMenuEventu: false,
            showLoader: false,
            czyPelenEkran: false,
            kolorRezerwacja: '#00152c',
            kolorSprzedany: '#001f05',
            kolorSkasowany: '#291801',


            pokazModal: false,
            modalTyp: '',
            ladowanieModala: false,
            eventDoModala: null,
        };
        this.onClickZapisz = this.onClickZapisz.bind(this)
        this.onClickZobaczBilety = this.onClickZobaczBilety.bind(this)
        this.onClickZobaczLokalizacje = this.onClickZobaczLokalizacje.bind(this)
        this.onClickPokazPelnyEkran = this.onClickPokazPelnyEkran.bind(this)

        this.onZmienStatusSave = this.onZmienStatusSave.bind(this)
    }

    componentDidMount() {
        this.pobierzKoloryStatusow()
        this.formatujEventy(this.props)
        if (this.props.czyUstawionoPelenWidokKalendarza) {
            this.setState({czyPelenEkran: true})
        }
    }

    componentWillReceiveProps(nextprops) {
        this.formatujEventy(nextprops)
        if (nextprops.czyUstawionoPelenWidokKalendarza) {
            this.setState({czyPelenEkran: true})
        }


    }

    componentDidUpdate() {


        $('#calendar').fullCalendar('destroy')
        $('#calendar').fullCalendar({
            schedulerLicenseKey: '0679243936-fcs-1547637957',
            height: $(window).height(),
            // height: 'parent',

            locale: 'pl',
            header: {
                left: 'prev,next',
                center: 'title',
                right: 'timelineDay,timelineEightDays,timelineTenDays,timelineMonthCustom'
            },
            titleFormat: 'DD MMMM YYYY',
            defaultView: (this.props.czyDataPoUpdateNaKalendarzu) ? 'timelineDay' : (this.props.czyWidokTygodniowyNaKalendarzu) ? 'timelineEightDays' : 'timelineDay',
            defaultDate: (this.props.czyDataPoUpdateNaKalendarzu) ? this.props.czyDataPoUpdateNaKalendarzu : (this.props.dataStart) ? this.props.dataStart : new Date().toJSON().substr(0, 10),
            views: {
                timelineDay: {
                    slotLabelFormat: 'HH:mm',
                    type: 'timelineDay',
                    // duration: {days: 1},
                    slotDuration: '00:15',
                    buttonText: 'dzień'
                },
                timelineEightDays: {
                    slotLabelFormat: 'ddd D.MM',
                    type: 'timelineMonth',
                    duration: {days: 7},
                    slotDuration: '24:00'
                },
                timelineTenDays: {
                    slotLabelFormat: 'ddd D.MM',
                    type: 'timelineMonth',
                    duration: {days: 14},
                    slotDuration: '24:00'
                },
                timelineMonthCustom: {
                    type: 'timelineMonth',
                    duration: {month: 1},
                    slotDuration: '24:00',
                    buttonText: 'miesiąc'
                }
            },
            events: this.state.events,
            eventRender: this.eventRender.bind(this),
            //   eventClick: this.eventClick.bind(this),
        })
    }

    pobierzKoloryStatusow() {
        KonfiguracjaService.pobierzObiektySekcji('Status-kolor').then(function (response) {
            if (Boolean(response.data)) {

                let arr = response.data.filter(p => p.sekcja === 'Status-kolor')

                if (arr.length > 0) {


                    if (Boolean(arr.find(p => p.pozycja == 'rezerwacja'))) {
                        if (Boolean((arr.find(p => p.pozycja == 'rezerwacja').wartosc))) {
                            this.setState({
                                kolorRezerwacja: arr.find(p => p.pozycja == 'rezerwacja').wartosc
                            })
                        }

                    }
                    if (Boolean(arr.find(p => p.pozycja == 'opłacony'))) {
                        if (Boolean((arr.find(p => p.pozycja == 'opłacony').wartosc))) {
                            this.setState({
                                kolorSprzedany: arr.find(p => p.pozycja == 'opłacony').wartosc
                            })
                        }

                    }
                    if (Boolean(arr.find(p => p.pozycja == 'skasowany'))) {
                        if (Boolean((arr.find(p => p.pozycja == 'skasowany').wartosc))) {
                            this.setState({
                                kolorSkasowany: arr.find(p => p.pozycja == 'skasowany').wartosc
                            })
                        }

                    }
                }

            }

        }.bind(this))
    }

    formatujEventy(props, czyZwrocic = false) {

        let arr = Array.from(props.obsady, item => {
            let sformatowanyCzasOdjazdu = DateAndTimeFormat.formatHHMM(item.godz_1p)


            let czastr = 1.5
            let trasa = props.trasy.find(t => t.idTr === item.id_tr)
            if (Boolean(trasa.czasTr)) {
                czastr = trasa.czasTr
            }
            let kolor = 'inherit'
            if (item.kolor) {
                if (item.kolor.length > 3) {
                    kolor = item.kolor
                }
            }
            let kod = ''
            if (Boolean(item.kod_ek)) {
                kod = item.kod_ek
            }

            let przyjazd = DateAndTimeFormat.dodajGodzineDoCzasu(new Date(item.data + ' ' + sformatowanyCzasOdjazdu), czastr)
            let przyjazdO = (przyjazd.getHours() + ':' + przyjazd.getMinutes())
            if (przyjazd.getMinutes() < 10) {
                przyjazdO = (przyjazd.getHours() + ':0' + przyjazd.getMinutes())
            }


            let info = '[' + item.id_ku + '] ' + trasa.nazTr + ', ' + sformatowanyCzasOdjazdu + ' -> ' + przyjazdO + ', ' + item.naz_ki + ', ' + item.naz_po


            // obliczanie wartosci do progressbaru

            let wszystkie = 25
            if (item.il_miejsc_kurs > 0) {
                wszystkie = item.il_miejsc_kurs
            }
            // wartości procentowe
            let zarezerwowaneProc = 0
            let sprzedaneProc = 0
            let skasowaneProc = 0
            let odbiciaProc = 0

            let ile_odbic = 0

            if (Boolean(item.ile_odb_mies_popr)) {
                ile_odbic = item.ile_odb_mies_popr
            }

            if (item)


                if (item.il_rez > 0) {
                    zarezerwowaneProc = (item.il_rez * 100) / wszystkie
                }
            if (item.il_sprz > 0) {
                sprzedaneProc = (item.il_sprz * 100) / wszystkie
            }
            if (item.il_skas > 0) {
                skasowaneProc = (item.il_skas * 100) / wszystkie
            }

            if (ile_odbic > 0) {
                odbiciaProc = (ile_odbic * 100) / wszystkie
            }

            let wolneMiejsca = wszystkie - (item.il_rez + item.il_sprz + item.il_skas+ile_odbic)

            let czyBrakujeMiejsc = false
            let brakujaceProc = 0

            if ((item.il_rez + item.il_sprz + item.il_skas+ile_odbic) > wszystkie) {
                czyBrakujeMiejsc = (item.il_rez + item.il_sprz + item.il_skas+ile_odbic) - wszystkie
                brakujaceProc = (czyBrakujeMiejsc * 100) / wszystkie
            }


            return {
                ...item,
                id: 'o' + item.id_ob,
                start: new Date(item.data + ' ' + sformatowanyCzasOdjazdu),
                end: DateAndTimeFormat.dodajGodzineDoCzasu(new Date(item.data + ' ' + sformatowanyCzasOdjazdu), czastr),
                naz_tr: Boolean(trasa) ? trasa.nazTr : '',
                kolor: kolor,
                kod_ek: kod,
                info: info,
                przyjazdO: przyjazdO,
                czas_tr: czastr,
                zarezerwowaneProc: zarezerwowaneProc,
                sprzedaneProc: sprzedaneProc,
                skasowaneProc: skasowaneProc,
                czyBrakujeMiejsc: czyBrakujeMiejsc,
                brakujaceProc: brakujaceProc,
                wolneMiejsca: wolneMiejsca,
                odbiciaProc:odbiciaProc,
                ile_odbic:ile_odbic
            }

        })

        this.setState({events: arr})
        if (czyZwrocic) {
            return arr
        }
    }

    eventClick(event, element) {
        console.log(element)
        //   this.setState({pokazMenuEventu: true, event: event})
    }

    onClickOdwolaj(event) {
        if (event.start_kursu) {
            if (window.confirm('Uwaga! Kurs został już rozpoczęty. Czy na pewno chcesz odwołać kurs?')) {
                this.setState({pokazModal: true, modalTyp: 'odblokuj', eventDoModala: event})
            }
        } else
            this.setState({pokazModal: true, modalTyp: 'odwolaj', eventDoModala: event})
    }

    onClickZablokuj(event,) {
        if (event.start_kursu) {
            if (window.confirm('Uwaga! Kurs został już rozpoczęty. Czy na pewno chcesz zablokować kurs?')) {
                this.setState({pokazModal: true, modalTyp: 'odblokuj', eventDoModala: event})
            }
        } else
            this.setState({pokazModal: true, modalTyp: 'zablokuj', eventDoModala: event})
    }

    onClickOdblokuj(event) {
        if (event.start_kursu) {
            if (window.confirm('Uwaga! Kurs został już rozpoczęty. Czy na pewno chcesz odblokowac kurs?')) {
                this.setState({pokazModal: true, modalTyp: 'odblokuj', eventDoModala: event})
            }
        } else
            this.setState({pokazModal: true, modalTyp: 'odblokuj', eventDoModala: event})
    }

    onClickDuplikuj(event) {
        if (event.start_kursu) {
            alert('Uwaga! Kurs został już rozpoczęty, proszę uważnie duplikować dane')
        }
        this.setState({pokazModal: true, modalTyp: 'duplikuj', eventDoModala: event})
    }

    onClickEdytujZasoby(event) {
        if (event.start_kursu) {
            alert('Uwaga! Kurs został już rozpoczęty, proszę uważnie edytować dane')
        }
        this.setState({pokazModal: true, modalTyp: 'edytuj', eventDoModala: event})
    }


    onClickZobaczLokalizacje(event) {
        LSService.ustawIdKursuDoWyszukaniaLokalizacji(event.id_ku)
        this.props.history.push('/konfiguracja/rozklad-jazdy/lokalizacja')
    }

    onClickZobaczBilety(event) {
        let params = {
            idTr: event.id_tr,
            godz: event.godz_1p,
            data: event.data
        }
        LSService.ustawWyszukiwanieBiletowZObsad(params);
        this.props.history.push('/konfiguracja/zarzadzanie-biletami/bilety-jednorazowe')
    }

    eventRender(event, element) {

        let czyUkrycPrzyciskiEdycjiIDuplikacji = (event.zablokowane === 2) ? 'none' : 'inline'
        let czyPokazacPrzyciskLokalizacji = ((event.data === new Date().toJSON().substr(0, 10)) && event.start_kursu && event.zablokowane !== 2) ? 'inline' : 'none'
        let czyUkrycPrzyciskOdwolania = (event.zablokowane === 2) ? 'none' : 'inline'
        let czyUkrycPrzyciskZablokowania = (event.zablokowane === 2 || event.zablokowane === 1) ? 'none' : 'inline'
        let czyUkrycPrzyciskOdblokowania = (event.zablokowane === 2 || event.zablokowane === 0) ? 'none' : 'inline'

        let czyZablokowane = ''

        let czyTelefonEBus = ''

        if (event.zablokowane == 1) {
            czyZablokowane = "<div class='obsadaKursZablokowane'><i class='fa fa-times'></i> KURS ZABLOKOWANY</div>"
        }
        else if (event.zablokowane == 2) {
            czyZablokowane = "<div class='obsadaKursOdwolane'><i class='fa fa-repeat'></i> KURS ODWOŁANY</div>"
        }
        else if (event.start_kursu && event.koniec_kursu) {
            czyZablokowane = "<div class='obsadaKursRozpoczety'><div><i class='fa fa-flag-checkered'></i> KURS ZAKOŃCZONY</div><div>O: " + event.koniec_kursu.substr(0, 10) + ' ' + event.koniec_kursu.substr(11, 5) + "</div></div>"
        }
        else if (event.start_kursu) {
            czyZablokowane = "<div class='obsadaKursRozpoczety'><div><i class='fa fa-check'></i> KURS ROZPOCZĘTY</div><div>O: " + event.start_kursu.substr(0, 10) + ' ' + event.start_kursu.substr(11, 5) + "</div></div>"
        }

        if (Boolean(event.nr_tel_ebus)) {
            czyTelefonEBus = "<p><i class='fa fa-phone'></i> " + event.nr_tel_ebus + "</p>"
        }

        if (Boolean(event.czyBrakujeMiejsc)) {
            element.html(
                "<div class='calendarObsadaItem' title='" + event.info + "'>" +
                "<div class='calendarObsadaItemColor' style='background:" + event.kolor + "'>" +
                "<div><span class='calendarObsadaItemIdKursu'>" + event.id_ku + "</span> " + event.kod_ek + "</div>" +
                "</div>" +
                czyZablokowane +
                "<div class='calendarObsadaItemContent'>" +
                "<p><i class='fa fa-road'></i>" + event.naz_tr + "</p>" +
                "<p><span><i class='fa fa-clock-o'></i>" + DateAndTimeFormat.formatHHMM(event.godz_1p) + " </span><span><i class='fa fa-long-arrow-right'></i>" + event.przyjazdO + "</span></p>" +
                "<p><i class='fa fa-user'></i>" + event.naz_ki + "</p>" +
                "<p><i class='fa fa-bus'></i>" + event.naz_po + "</p>" +
                czyTelefonEBus +
                "<div>" +
                "<div class='progress' style='margin-bottom: 5px'>" +
                "<div class='progress-bar progress-bar-danger' role='progressbar' aria-valuenow='" + event.brakujaceProc + "' aria-valuemin='0' aria-valuemax='100' style='width: " + event.brakujaceProc + "%;'>" +
                "</div>" +
                "</div>" +
                "</div>" +
                "<div style='font-weight: bold; font-size: 14px; overflow-x: auto''>" +
                "<span style='color:" + this.state.kolorRezerwacja + "'>R: " + event.il_rez + "</span> | " +
                "<span style='color:" + this.state.kolorSprzedany + "'>S: " + event.il_sprz + "</span> | " +
                "<span style='color:" + this.state.kolorSkasowany + "'>Sk: " + event.il_skas + "</span> | " +
                "<span style='color:#a83da7'>Odb popr: " + event.ile_odb_mies_popr + "</span> | " +
                "<span style='color:red'>Odb niepopr: " + event.ile_odb_mies_niepopr + "</span> | " +
                "<span style='color:firebrick'>B: " + event.czyBrakujeMiejsc + "</span>" +
                "</div>" +
                "<div class='btn-toolbar' style='margin-top: 5px'>" +
                "<button type='button' class='btn btn-primary btn-small zobaczBiletyButton' title='Zobacz bilety na kurs'><i class='fa fa-ticket'></i></button>" +
                "<button type='button' class='btn btn-primary btn-small zobaczLokalizacjeButton' title='Zobacz lokalizacje busa' style='display:" + czyPokazacPrzyciskLokalizacji + "'><i class='fa fa-map-marker'></i></button>" +
                "<button type='button' class='btn btn-success btn-small duplikujButton' title='Duplikuj kurs' style='display:" + czyUkrycPrzyciskiEdycjiIDuplikacji + "'><i class='fa fa-user-plus'></i></button>" +
                "<button type='button' class='btn btn-default btn-small edytujZasobyButton' title='Edytuj kierowcę i pojazd' style='color:dodgerblue; display:" + czyUkrycPrzyciskiEdycjiIDuplikacji + "'><i class='fa fa-edit'></i></button>" +
                "<button type='button' class='btn btn-default btn-small odblokujButton' title='Odblokuj kurs' style='color:forestgreen; display:" + czyUkrycPrzyciskOdblokowania + "'><i class='fa fa-check'></i></button>" +
                "<button type='button' class='btn btn-default btn-small zablokujButton' title='Zablokuj kurs' style='color:darkorange; display:" + czyUkrycPrzyciskZablokowania + "'><i class='fa fa-times'></i></button>" +
                "<button type='button' class='btn btn-default btn-small odwolajButton' title='Odwołaj kurs' style='color:firebrick; display:" + czyUkrycPrzyciskOdwolania + "'><i class='fa fa-repeat'></i></button>" +
                "</div>" +
                "</div>" +
                "</div>");
        }
        else {
            element.html(
                "<div class='calendarObsadaItem' title='" + event.info + "'>" +
                "<div class='calendarObsadaItemColor' style='background:" + event.kolor + "'>" +
                "<div><span class='calendarObsadaItemIdKursu'>" + event.id_ku + "</span> " + event.kod_ek + "</div>" +
                "</div>" +
                czyZablokowane +
                "<div class='calendarObsadaItemContent'>" +
                "<p><i class='fa fa-road'></i>" + event.naz_tr + "</p>" +
                "<p><span><i class='fa fa-clock-o'></i>" + DateAndTimeFormat.formatHHMM(event.godz_1p) + " </span><span><i class='fa fa-long-arrow-right'></i>" + event.przyjazdO + "</span></p>" +
                "<p><i class='fa fa-user'></i>" + event.naz_ki + "</p>" +
                "<p><i class='fa fa-bus'></i>" + event.naz_po + "</p>" +
                czyTelefonEBus +
                "<div>" +
                "<div class='progress' style='margin-bottom: 5px'>" +
                "<div class='progress-bar' role='progressbar' aria-valuenow='" + event.zarezerwowaneProc + "' aria-valuemin='0' aria-valuemax='100' style='width: " + event.zarezerwowaneProc + "%;'>" +
                "</div>" +
                "<div class='progress-bar progress-bar-success' role='progressbar' aria-valuenow='" + event.sprzedaneProc + "' aria-valuemin='0' aria-valuemax='100' style='width: " + event.sprzedaneProc + "%;'>" +
                "</div>" +
                "<div class='progress-bar progress-bar-warning' role='progressbar' aria-valuenow='" + event.skasowaneProc + "' aria-valuemin='0' aria-valuemax='100' style='width: " + event.skasowaneProc + "%;'>" +
                "</div>" +
                "<div class='progress-bar progress-bar-info' role='progressbar' aria-valuenow='" + event.odbiciaProc + "' aria-valuemin='0' aria-valuemax='100' style='width: " + event.odbiciaProc + "%; background: #a83da7'>" +
                "</div>" +
                "</div>" +
                "</div>" +
                "<div style='font-weight: bold; font-size: 14px; overflow-x: auto'>" +
                "<span style='color:" + this.state.kolorRezerwacja + "'>R: " + event.il_rez + "</span> | " +
                "<span style='color:" + this.state.kolorSprzedany + "'>S: " + event.il_sprz + "</span> | " +
                "<span style='color:" + this.state.kolorSkasowany + "'>Sk: " + event.il_skas + "</span> | " +
                "<span style='color:#a83da7'>Odb popr: " + event.ile_odb_mies_popr + "</span> | " +
                "<span style='color:red'>Odb niepopr: " + event.ile_odb_mies_niepopr + "</span> | " +
                "<span style='color:black'>W: " + event.wolneMiejsca + "</span>" +
                "</div>" +
                "<div class='btn-toolbar' style='margin-top: 5px'>" +
                "<button type='button' class='btn btn-primary btn-small zobaczBiletyButton' title='Zobacz bilety na kurs'><i class='fa fa-ticket'></i></button>" +
                "<button type='button' class='btn btn-primary btn-small zobaczLokalizacjeButton' title='Zobacz lokalizacje busa' style='display:" + czyPokazacPrzyciskLokalizacji + "'><i class='fa fa-map-marker'></i></button>" +
                "<button type='button' class='btn btn-success btn-small duplikujButton' title='Duplikuj kurs' style='display:" + czyUkrycPrzyciskiEdycjiIDuplikacji + "'><i class='fa fa-user-plus'></i></button>" +
                "<button type='button' class='btn btn-default btn-small edytujZasobyButton' title='Edytuj kierowcę i pojazd' style='color:dodgerblue; display:" + czyUkrycPrzyciskiEdycjiIDuplikacji + "'><i class='fa fa-edit'></i></button>" +
                "<button type='button' class='btn btn-default btn-small odblokujButton' title='Odblokuj kurs' style='color:forestgreen; display:" + czyUkrycPrzyciskOdblokowania + "'><i class='fa fa-check'></i></button>" +
                "<button type='button' class='btn btn-default btn-small zablokujButton' title='Zablokuj kurs' style='color:darkorange; display:" + czyUkrycPrzyciskZablokowania + "'><i class='fa fa-times'></i></button>" +
                "<button type='button' class='btn btn-default btn-small odwolajButton' title='Odwołaj kurs' style='color:firebrick; display:" + czyUkrycPrzyciskOdwolania + "'><i class='fa fa-repeat'></i></button>" +
                "</div>" +
                "</div>" +
                "</div>");

        }

        element.find(".odwolajButton").click(() => this.onClickOdwolaj(event))
        element.find(".odblokujButton").click(() => this.onClickOdblokuj(event))
        element.find(".zablokujButton").click(() => this.onClickZablokuj(event))
        element.find(".duplikujButton").click(() => this.onClickDuplikuj(event))
        element.find(".edytujZasobyButton").click(() => this.onClickEdytujZasoby(event))
        element.find(".zobaczLokalizacjeButton").click(() => this.onClickZobaczLokalizacje(event))
        element.find(".zobaczBiletyButton").click(() => this.onClickZobaczBilety(event))
    }

    onClickZapisz(obj) {
        console.log(obj)
    }

    onClickPokazPelnyEkran() {
        this.setState({
            czyPelenEkran: !this.state.czyPelenEkran
        })
        this.props.handleClickUstawieniePelnegoEkranu(!this.state.czyPelenEkran)
    }

    onZmienStatusSave(obj, action) {
        this.setState({
            pokazModal: false,
            ladowanieModala: false,
            modalTyp: '',
        })

        this.props.handlePobierzObsade(obj, action)

    }

    zamknijModal() {
        this.setState({
            pokazModal: false,
            ladowanieModala: false,
            modalTyp: '',
        })
    }

    render() {

        return (
            <div>
                <ReactNotify ref='notificator'/>
                <TopIf isTrue={this.state.showLoader}>
                    <div id={'smallLoader'}>
                        <i className={'fa fa-circle-o-notch fa-spin'}></i>
                        <div>Trwa ładowanie kalendarza...</div>
                    </div>
                </TopIf>
                <div className={(this.state.czyPelenEkran) ? 'kalendarzPelenEkran' : ''}>
                    <TopIf isTrue={this.state.pokazMenuEventu}>
                        <KalendarzEventMenu event={this.state.event}
                                            handleZamknijMenu={
                                                () => {
                                                    this.setState({
                                                        pokazMenuEventu: false, event: null
                                                    })
                                                }
                                            }
                                            kolorRezerwacja={this.state.kolorRezerwacja}
                                            kolorSprzedany={this.state.kolorSprzedany}
                                            kolorSkasowany={this.state.kolorSkasowany}
                                            history={this.props.history}
                        />
                    </TopIf>
                    <div>
                        <div className={'pull-right'}>
                            <TopButtonAction btnColor={'default'}
                                             text={(this.state.czyPelenEkran) ? 'Zamknij pełen ekran' : 'Pokaż na pełnym ekranie'}
                                             iconType={(this.state.czyPelenEkran) ? 'fa fa-times' : 'fa fa-external-link'}
                                             onClick={this.onClickPokazPelnyEkran}/>
                        </div>
                    </div>
                    <div id="calendar"></div>
                </div>
                <TopIf isTrue={this.state.pokazModal}>
                    <div id={'EBUSModalContainerBG'}>
                        <div id={'modalContainer'}>
                            <div>
                                <div className={'pull-right'}>
                                    <TopButtonAction onClick={() => {
                                        this.setState({
                                            pokazModal: false,
                                            ladowanieModala: false,
                                            modalTyp: '',
                                        })
                                    }}
                                                     elementStyle={{color: 'firebrick'}}
                                                     btnColor={'default'} text={'Zamknij'} iconType={'fa fa-times'}
                                    />
                                </div>
                                <div style={{clear: 'both'}}></div>
                                {
                                    Boolean(this.state.ladowanieModala) ?
                                        <div id={'ladowanieModala'}>
                                            <i className={'fa fa-circle-o-notch fa-spin'}></i>
                                            <h6>Trwa ładowanie danych</h6>
                                        </div>
                                        :
                                        <div id={'modalTextContent'}>
                                            {
                                                Boolean(this.state.modalTyp === 'duplikuj') ?
                                                    <KalendarzModalDuplikujKurs
                                                        event={this.state.eventDoModala}
                                                        onClickAnuluj={() => {
                                                            this.setState({
                                                                pokazModal: false,
                                                                ladowanieModala: false,
                                                                modalTyp: '',
                                                            })
                                                        }}
                                                        afterClickZapisz={(obj, action, objrest) => {
                                                            this.props.handlePobierzObsade(obj, action, objrest)
                                                            this.zamknijModal()
                                                        }}
                                                        trasy={this.props.trasy}
                                                    />
                                                    :
                                                    Boolean(this.state.modalTyp === 'edytuj') ?
                                                        <KalendarzModalEdytujZasoby
                                                            event={this.state.eventDoModala}
                                                            onClickAnuluj={() => {
                                                                this.setState({
                                                                    pokazModal: false,
                                                                    ladowanieModala: false,
                                                                    modalTyp: '',
                                                                })
                                                            }}
                                                            afterClickZapisz={(obj, action, objrest) => {
                                                                this.props.handlePobierzObsade(obj, action, objrest)
                                                                this.zamknijModal()
                                                            }}
                                                        />
                                                        :
                                                        <KalendarzModalZmienStatus modalTyp={this.state.modalTyp} event={this.state.eventDoModala}
                                                                                   onClickAnuluj={() => {
                                                                                       this.setState({
                                                                                           pokazModal: false,
                                                                                           ladowanieModala: false,
                                                                                           modalTyp: '',
                                                                                       })
                                                                                   }}
                                                                                   afterClickZapisz={this.onZmienStatusSave}
                                                        />
                                            }
                                        </div>
                                }
                            </div>
                        </div>
                    </div>
                </TopIf>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/obsada/ObsadaKalendarz/ObsadaKalendarzContainer.js